import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import AppButton from "./forms/button";
import PropTypes from "prop-types";
import { useAuthLogout } from "../auth/authLogout";

export default function HeaderComponent({ onMenuClick, isMenuOpen, isError }) {
  const { authState } = {};
  const isLoggedIn = authState?.isAuthenticated;
  const { t } = useTranslation();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { appLogout } = useAuthLogout();
  return (
    <AppBar
      position="fixed"
      className="h-[96px] md:h-[76px]"
      sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, left: "0px" }}
    >
      <Toolbar className="h-full flex items-center gap-2 sm:gap-4 px-0 sm:px-0">
        <Box className="flex items-center" sx={{ pl: "20px" }}>
          <img src="/image/new_logo.svg" alt="Logo" />
        </Box>
        <div className="flex-grow"></div>
        {isMobile && !isError && (
          <IconButton
            color="inherit"
            edge="start"
            onClick={onMenuClick}
            sx={{ mr: 1 }}
          >
            {isMenuOpen ? (
              <CloseIcon
                sx={{ width: 44, height: 44 }}
                className="border rounded-md p-1"
              />
            ) : (
              <MenuIcon
                sx={{ width: 44, height: 44 }}
                className="border rounded-md p-1"
              />
            )}
          </IconButton>
        )}
        {isLoggedIn && (
          <AppButton
            variant="text"
            className="!text-brandDark mr-2 !bg-buttonColor"
            text={t("contact-us")}
          ></AppButton>
        )}
        {!isMobile && !isError && (
          <AppButton
            variant="text"
            className="text-white text-base gap-0 mr-4 px-4 py-2 rounded-lg border-2 border-white border-solid "
            text={t("logout")}
            onClick={appLogout}
          ></AppButton>
        )}
      </Toolbar>
    </AppBar>
  );
}

HeaderComponent.propTypes = {
  onMenuClick: PropTypes.any.isRequired,
  isMenuOpen: PropTypes.any.isRequired,
  isError: PropTypes.bool,
};
